import { render, staticRenderFns } from "./TableGroupItem.vue?vue&type=template&id=498ea014"
import script from "./TableGroupItem.vue?vue&type=script&lang=js"
export * from "./TableGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498ea014')) {
      api.createRecord('498ea014', component.options)
    } else {
      api.reload('498ea014', component.options)
    }
    module.hot.accept("./TableGroupItem.vue?vue&type=template&id=498ea014", function () {
      api.rerender('498ea014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableGroupItem.vue"
export default component.exports